import React, { useMemo } from "react";
import usePluggableEventActions from "components/events/events/hooks/usePluggableEventActions";
import { MenuItem } from "components/bootstrap";
import LinkToReplaySearch from "components/event-definitions/replay-search/LinkToReplaySearch";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import usePermissions from "hooks/usePermissions";
const useEventAction = (event) => {
  const { actions: pluggableActions, actionModals: pluggableActionModals } = usePluggableEventActions([event]);
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const hasReplayInfo = !!event.replay_info;
  const permissions = usePermissions();
  const isPermitted = permissions.isPermitted(`eventdefinitions:edit:${event.event_definition_id}`);
  const moreActions = useMemo(
    () => [
      hasReplayInfo && isPermitted ? /* @__PURE__ */ React.createElement(
        LinkToReplaySearch,
        {
          key: "replay-search",
          isMenuitem: true,
          onClick: () => sendEventActionTelemetry("REPLAY_SEARCH", false),
          id: event.id,
          isEvent: true
        }
      ) : null,
      pluggableActions.length && hasReplayInfo ? /* @__PURE__ */ React.createElement(MenuItem, { divider: true, key: "divider" }) : null,
      pluggableActions.length ? pluggableActions : null
    ].filter(Boolean),
    [sendEventActionTelemetry, event.id, hasReplayInfo, pluggableActions, isPermitted]
  );
  return { moreActions, pluggableActionModals };
};
export default useEventAction;
